var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataQualityCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.775,
    y1: 0.086,
    x2: 0.148,
    y2: 0.829,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ed98a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20731a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3127",
    "data-name": "Rectangle 3127",
    width: 38,
    height: 32,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13693",
    "data-name": "Group 13693",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(12 12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13703",
    "data-name": "Group 13703",
    transform: "translate(23 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13702",
    "data-name": "Group 13702",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13070",
    "data-name": "Path 13070",
    d: "M25.336,2.269A2.26,2.26,0,0,0,23.091,0H2.244A2.258,2.258,0,0,0,0,2.269V7.663H25.336ZM11.917,4.577H4.436a.757.757,0,0,1,0-1.513h7.481a.757.757,0,0,1,0,1.513m4.794.461a1.207,1.207,0,1,1,1.181-1.193A1.2,1.2,0,0,1,16.711,5.038Zm3.74,0a1.207,1.207,0,1,1,1.181-1.193A1.2,1.2,0,0,1,20.451,5.038Zm4.885,4.138H0v6.052H25.336ZM12,12.959H4.518a.757.757,0,0,1,0-1.513H12a.757.757,0,0,1,0,1.513Zm4.786.461a1.211,1.211,0,1,1,1.179-1.191A1.2,1.2,0,0,1,16.785,13.42Zm3.74,0A1.211,1.211,0,1,1,21.7,12.229,1.2,1.2,0,0,1,20.525,13.42Zm4.811,3.737v-.416H0v6.052H21.805A9,9,0,0,1,25.336,17.157ZM12,20.524H4.518a.757.757,0,0,1,0-1.513H12a.757.757,0,0,1,0,1.513Zm4.786.461a1.211,1.211,0,1,1,1.177-1.19A1.2,1.2,0,0,1,16.785,20.985Zm3.74,0a1.211,1.211,0,1,1,1.18-1.192A1.2,1.2,0,0,1,20.525,20.985Zm1.122,3.473a.962.962,0,0,1,.009-.152H0V29.73A2.259,2.259,0,0,0,2.244,32H23.091a2.194,2.194,0,0,0,1.646-.734A9.012,9.012,0,0,1,21.647,24.458Zm-9.73,4.44H4.436a.757.757,0,0,1,0-1.513h7.481a.757.757,0,0,1,0,1.513m4.794.462a1.207,1.207,0,1,1,1.194-1.207A1.2,1.2,0,0,1,16.711,29.36Zm3.74,0a1.207,1.207,0,1,1,1.193-1.207A1.2,1.2,0,0,1,20.451,29.36Zm10.12-12.414c-6.6-.047-9.894,8.26-5.235,12.83C29.883,34.453,38.044,31.09,38,24.457A7.479,7.479,0,0,0,30.571,16.946Zm3.936,5.3-4.458,5.4a.887.887,0,0,1-.577.273.855.855,0,0,1-.569-.273L26.637,24.9a.761.761,0,0,1,.11-1.061.74.74,0,0,1,1.034.093l1.691,2.05,3.89-4.7a.74.74,0,0,1,1.052-.075A.761.761,0,0,1,34.507,22.241Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataQualityCheck);
export default __webpack_public_path__ + "static/media/dataQualityCheck.6e9e9c28d4902cb9150596ebc3a83688.svg";
export { ForwardRef as ReactComponent };